import swal from "sweetalert2";
<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-4">
        <ArtistSelect class="artist-selection" @memberChangeEvent="getArtistInfo" :is-filter="true" :show-all-units="true" :show-members="false" />
      </div>
      <div class="col-sm-4">
        <h4 class="card-title text-left">타입</h4>
        <div class="row">
          <el-select class="col-md-12 select-primary" @change="getBlackList(1)" size="large" placeholder="상태" v-model="type">
            <el-option v-for="option in types" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-sm-4">
        <h4 class="card-title text-left">키워드</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-input placeholder="키워드" v-model="keyword">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="getBlackList(1, true)" type="default">검색</base-button>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="addKeyword" type="default">추가</base-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <el-table :data="data">
        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
        <el-table-column :min-width="100" align="right" label="삭제">
          <div slot-scope="props">
            <base-button @click.native="deleteKeyword(props.row.id)" type="warning" size="sm" icon>
              <i class="tim-icons icon-simple-delete" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { Table, TableColumn } from "element-ui";
import { BaseInput, BasePagination } from "@/components/index";
import { showAPIErrorToast } from "@/util/ErrorUtils";
import swal from "sweetalert2";

export default {
  components: {
    ArtistSelect,
    BaseInput,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
  },
  async created() {
    await this.getBlackList();
  },
  data() {
    return {
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "unitName",
          label: "아티스트",
          minWidth: 100,
        },
        {
          prop: "keyword",
          label: "블랙키워드",
          minWidth: 100,
        },
        {
          prop: "type",
          label: "타입",
          minWidth: 100,
        },
      ],
      data: [],
      keyword: null,
      type: 1,
      types: [
        {
          label: "완전일치",
          value: 1,
        },
        {
          label: "?부분일치?",
          value: 2,
        },
        {
          label: "부분일치?",
          value: 3,
        },
        {
          label: "?부분일치",
          value: 4,
        },
      ],
      currentPage: 1,
      totalPages: null,
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getBlackList(this.currentPage);
      },
    },
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      await this.getBlackList(1);
    },
    async getBlackList(page, withKeyword) {
      const params = { unitId: this.unitId, type: this.type };
      params.currentPage = page ? page : 1;
      if (withKeyword) {
        params.keyword = this.keyword;
      }
      return this.$axios.get("/users/nickname/blackList", { params }).then((res) => {
        this.data = res.data.data.data;
        this.totalPages = Number(res.data.data.page);
      });
    },
    async addKeyword() {
      if (this.keyword === "" || !this.keyword) {
        Toast.error("키워드를 입력해주세요");
        return;
      }
      const params = { unitId: this.unitId, keyword: this.keyword, type: this.type };
      try {
        await this.$axios.post("/users/nickname/blackList", { params });
        Toast.success("추가되었습니다");
        this.keyword = null;
        await this.getBlackList(1);
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async deleteKeyword(id) {
      swal
        .fire({
          title: "삭제 확인",
          text: `${id} 키워드 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              const params = { id };
              await this.$axios.delete("/users/nickname/blackList", { params });
              Toast.success("삭제되었습니다");

              await this.getBlackList();
            } catch (err) {
              Toast.error("키워드 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
